import type { AdminUser } from '@/types'

export const hasAdminProfileChanges = (
  user: AdminUser,
  values: { email: string; username: string; role_id: string }
): boolean =>
  values.email !== user.email
  || values.username !== user.username
  || values.role_id !== (user.role_id || user.role_code || '')

export const hasAdminStatusChange = (user: AdminUser, isActive: boolean): boolean =>
  isActive !== user.is_active
